export function parseConfigNumber(data?: string, defaultValue?: number) {
  return data ? parseFloat(data) : defaultValue;
}

export function parseConfigBoolean(data?: string) {
  if (typeof data === 'undefined') {
    return undefined;
  }

  if (data === 'true' || data === 'false') {
    return data === 'true';
  }

  throw new Error(`Invalid boolean value: "${data}"`);
}
